// GMAPS
var self = module.exports = {
    coord: conf.gmaps.coord,
    position: null,
    map: null,
    loaded: false,
    image_pin: 'images/pin.png',
    places: { 
        'lazer': { 
            status: false, 
            grupos:  ['park', 'museum', 'movie_theater', 'movie_rental', 'bowling_alley', 'art_gallery', 'aquarium', 'shopping_mall'],
            icone: 'images/pin-lazer.png',
            marcadores: []
        },
        'educacao': { 
            status: false, 
            grupos:  ['school', 'university', 'library', 'book_store'],
            icone: 'images/pin-educacao.png',
            marcadores: []
        },
        'gastronomia': { 
            status: false, 
            grupos:  ['bakery', 'bar', 'cafe', 'food', 'restaurant', 'meal_delivery'],
            icone: 'images/pin-gastronomia.png',
            marcadores: []
        },
        'saude': { 
            status: false, 
            grupos:  ['hospital', 'pharmacy', 'health', 'doctor', 'dentist', 'spa', 'physiotherapist'],
            icone: 'images/pin-saude.png',
            marcadores: []
        },
        'comodidade': { 
            status: false, 
            grupos:  ['parking', 'grocery_or_supermarket', 'taxi_stand', 'supermarket', 'beauty_salon', 'bank','bus_station', 'car_wash', 'clothing_store','electronics_store', 'hardware store', 'subway_station'],
            icone: 'images/pin-comodidade.png',
            marcadores: []
        }
    },

    init: function(){
        
        $('#map-canvas').on('click', self.load);
        $('.places a').on('click', function(e){
            e.preventDefault();
            var tipo = $(this).data('place');
            self.load(tipo);
        });

        $('.mapa .btn-ampliar-mapa').on('click', function(e){
            e.preventDefault();
            $('body').toggleClass('amplia-mapa');
            self.load();
        })
    },

    load: function(tipo){
        if(!self.loaded){
            var sgmapsa = document.createElement('script'),
            sgmapsb = document.getElementsByTagName('script')[0];
            sgmapsa.src = '//maps.googleapis.com/maps/api/js?key='+conf.gmaps.key+'&v=3.exp&libraries=places';
            sgmapsb.parentNode.insertBefore(sgmapsa, sgmapsb);

            sgmapsa.onload = function () {
                self.position = new google.maps.LatLng(self.coord.lat, self.coord.lng);
                self.load_map(tipo);
            }
            self.loaded = true;
        }
    },

    load_map: function(tipo){
        var options = {
            zoom: 16,
            scrollwheel: false,
            center: self.position,
            disableDefaultUI: true,
            zoomControl: true
        }
        var styles = [ { "stylers": [ { "saturation": -100 } ] }, {"elementType": "labels.icon","stylers": [{"visibility": "off"}]}, ];

        self.map = new google.maps.Map(document.getElementById("map-canvas"), options);
        self.map.setOptions({styles: styles});
        
        marker = new google.maps.Marker({
            map: self.map,
            icon: self.image_pin,
            position: self.position
        });
    
        $('.places a').off().on('click', function(e){
            e.preventDefault();
            var tipo = $(this).data('place');
            self.load_places(tipo);
        });

        $('.places a[data-place="'+tipo+'"]').trigger('click');
    },

    load_places: function(tipo) {
        if (self.places[tipo].status){
            self.places[tipo].status = false;

            for (x = 0; x < self.places[tipo].marcadores.length; x++) {
                self.places[tipo].marcadores[x].setMap(null);
            }
            
            $('.places a[data-place=' + tipo + ']').removeClass('ativo');

        }else{
            self.places[tipo].status = true;
            var request = {
                location: self.position,
                radius: 2000,
                types: self.places[tipo].grupos
            };
            var infowindow = new google.maps.InfoWindow();
            var service = new google.maps.places.PlacesService(self.map);
            service.nearbySearch(request, function (results, status) {
                if (status == google.maps.places.PlacesServiceStatus.OK) {
                    for (var i = 0; i < results.length; i++) {
                        self.places[tipo].marcadores[i] = new google.maps.Marker({
                            map: self.map,
                            position: results[i].geometry.location,
                            icon: self.places[tipo].icone,
                            name: results[i].name
                        });
                        google.maps.event.addListener(self.places[tipo].marcadores[i], 'click', function () {
                            infowindow.setContent(this.name);
                            infowindow.open(self.map, this);
                        });
                    }
                    $('.places a[data-place=' + tipo + ']').addClass('ativo');
                }
            });
        }
    }
}